export const ENTITY_TYPES = [
  "PT",
  "Yayasan",
  "Universitas",
  "Organisasi",
  "Perkumpulan",
  "UD",
];
